import {
  Footer,
  FooterAffix,
  FooterAppDownload,
  FooterLinkSection,
} from "@kunduz/ui-components";
import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import { getQIUrl } from "@kunduz/utility-common";
import YT from "@icons/youtubeIconV2.svg";
import Insta from "@icons/instagramIconV2.svg";
import FB from "@icons/facebookIcon.svg";
import LIN from "@icons/linkedinIcon.svg";
import TW from "@icons/twitterIcon.svg";

export const WebsiteEnFooter = (): ReactElement => {
  const { t } = useTranslation("kunduzcom_common");

  const courses = [
    {
      label: "Algebra",
      slug: "algebra",
    },
    {
      label: "Calculus",
      slug: "calculus",
    },
    {
      label: "Statistics",
      slug: "statistics",
    },
    {
      label: "Geometry",
      slug: "geometry",
    },
    {
      label: "Physics",
      slug: "physics",
    },
    {
      label: "Physical Chemistry",
      slug: "physical-chemistry",
    },
    {
      label: "Organic Chemistry",
      slug: "organic-chemistry",
    },
    {
      label: "Inorganic Chemistry",
      slug: "inorganic-chemistry",
    },
    {
      label: "Biology",
      slug: "biology",
    },
    {
      label: "Microeconomics",
      slug: "microeconomics",
    },
    {
      label: "Computer Science Principles",
      slug: "computer-science-principles",
    },
    {
      label: "Computer Science Application",
      slug: "computer-science-application",
    },
    {
      label: "Accounting",
      slug: "accounting",
    },
    {
      label: "Finance",
      slug: "finance",
    },
    {
      label: "Psychology",
      slug: "psychology",
    },
    {
      label: "Mechanical Engineering",
      slug: "mechanical-engineering",
    },
    {
      label: "Chemical Engineering",
      slug: "chemical-engineering",
    },
    {
      label: "Electrical Engineering",
      slug: "electrical-engineering",
    },
    {
      label: "Anatomy and Physiology",
      slug: "anatomy-and-physiology",
    },
  ];
  const popularSubjects = [
    {
      label: "Quadratic Equations",
      courseSlug: "algebra",
      subjectSlug: "quadratic-equations",
    },
    {
      label: "Statistics",
      courseSlug: "statistics",
      subjectSlug: "statistics",
    },
    {
      label: "Sequences & Series",
      courseSlug: "algebra",
      subjectSlug: "sequences-series",
    },
    {
      label: "Basic Math",
      courseSlug: "math-others",
      subjectSlug: "basic-maths",
    },
    {
      label: "Limits & Continuity",
      courseSlug: "calculus",
      subjectSlug: "limits-and-continuity",
    },
    {
      label: "The Living World",
      courseSlug: "biology",
      subjectSlug: "the-living-world",
    },
    {
      label: "Basic Physics",
      courseSlug: "physics",
      subjectSlug: "basic-physics",
    },
    {
      label: "Probability",
      courseSlug: "statistics",
      subjectSlug: "probablity",
    },
    {
      label: "General Anatomy",
      courseSlug: "anatomy-and-physiology",
      subjectSlug: "general-anatomy",
    },
    {
      label: "General Physical Chemistry",
      courseSlug: "physical-chemistry",
      subjectSlug: "general",
    },
    {
      label: "Matrices & Determinants",
      courseSlug: "algebra",
      subjectSlug: "matrices-determinants",
    },
    {
      label: "Vector Calculus",
      courseSlug: "calculus",
      subjectSlug: "vector-calculus",
    },
    {
      label: "Application of derivatives",
      courseSlug: "calculus",
      subjectSlug: "application-of-derivatives",
    },
    {
      label: "Definite Integrals",
      courseSlug: "calculus",
      subjectSlug: "differentiation",
    },
    {
      label: "Differentiation",
      courseSlug: "calculus",
      subjectSlug: "differentiation",
    },
    {
      label: "Complex Numbers",
      courseSlug: "algebra",
      subjectSlug: "complex-numbers",
    },
    {
      label: "Trigonometry",
      courseSlug: "math",
      subjectSlug: "trigonometry",
    },
    {
      label: "Permutations and Combinations",
      courseSlug: "algebra",
      subjectSlug: "permutations-and-combinations",
    },
    {
      label: "Introduction to Physiology",
      courseSlug: "anatomy-and-physiology",
      subjectSlug: "Introduction-to-physiology",
    },
    {
      label: "Indefinite Integration",
      courseSlug: "calculus",
      subjectSlug: "indefinite-integration",
    },
  ];

  return (
    <Footer
      firstColumnLinks={
        <>
          <FooterLinkSection
            title="Pages"
            links={[
              {
                label: "Homework Help",
                slug: "/",
              },
              {
                label: "Students",
                slug: "/en-us/students/",
              },
              {
                label: "Questions Asked",
                slug: "/questions/",
              },
              {
                label: "Kunduz TR",
                slug: "/",
                locale: "tr",
              },
              {
                label: "Questions Asked TR",
                slug: "/sorular/",
                locale: "tr",
              },
            ]}
          />
          <FooterLinkSection
            title="Products"
            links={[
              {
                label: "Expert Q&A",
                slug: "/#unlimited_qa",
              },
              {
                label: "Live Chat",
                slug: "/#chat_tutor",
              },
              {
                label: "School Dashboard",
                slug: "/#school_dashboard",
              },
            ]}
          />
        </>
      }
      secondColumnLinks={
        <FooterLinkSection
          title="Courses"
          links={courses.map((c, i) => ({
            label: c.label,
            slug: getQIUrl({ lang: "en", courseSlug: c.slug }),
          }))}
        />
      }
      thirdColumnLinks={
        <FooterLinkSection
          title="Popular Subjects"
          links={popularSubjects.map((c, i) => ({
            label: c.label,
            slug: getQIUrl({
              lang: "en",
              courseSlug: c.courseSlug,
              subjectSlug: c.subjectSlug,
            }),
          }))}
        />
      }
      forthColumnLinks={
        <>
          <FooterLinkSection
            title="Corporate"
            links={[
              {
                label: "About Us",
                slug: "/about-us/",
              },
              {
                label: "Why Kunduz?",
                slug: "/",
              },
              {
                label: "Blog",
                slug: "/blog/",
              },
            ]}
          />
          <FooterLinkSection
            title="Legal"
            links={[
              {
                label: "Privacy Policy",
                slug: "/privacy-policy/",
              },
              {
                label: "Terms of Use",
                slug: "/terms-of-use/",
              },
            ]}
          />
          <FooterAppDownload
            title="Apps"
            items={[
              {
                imageUrl: "/images/applestore.webp",
                link: "https://apps.apple.com/tr/app/kunduz-yks-lgs-soru-%C3%A7%C3%B6z%C3%BCm%C3%BC/id1083827128?l=tr",
              },
              {
                imageUrl: "/images/googleplay.webp",
                link: "https://play.google.com/store/apps/details?id=com.ngier.roket&hl=tr",
              },
            ]}
          />
        </>
      }
      affix={
        <FooterAffix
          socialLinks={[
            { icon: TW, slug: "https://x.com/askkunduz" },
            { icon: Insta, slug: t("learning_footer_instagram_link") },
            { icon: FB, slug: t("learning_footer_facebook_link") },
            {
              icon: YT,
              slug: t("learning_footer_youtube_link"),
            },
            { icon: LIN, slug: "https://www.linkedin.com/company/kunduz/" },
          ]}
        />
      }
    />
  );
};
